import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { DEPRECATED_Card, Form, FormField, RadioGroup, useForm, useTranslations } from "@jti/ui";
import { useSubscription } from "../../hooks";
import { useFreeTrial } from "../../hooks/useFreeTrial";
import PaymentMethod from "../PaymentMethod";
import styles from "./PaymentMethodSelector.module.scss";
export const PaymentMethodSelector = ({ methods, onSelect }) => {
    const { __ } = useTranslations();
    const [selectedPayment, setSelectedPayment] = useState("");
    const { isSubscription } = useSubscription();
    const { isFreeTrial } = useFreeTrial();
    const form = useForm({
        defaultValues: {
            code: "",
        },
    });
    const code = form.watch("code");
    const firstMethodCode = methods.length > 0 && methods[0].code;
    useEffect(() => {
        if (!methods.length) {
            return;
        }
        if (isSubscription || isFreeTrial) {
            const tokenizableMethods = methods.filter((method) => method.tokenizable);
            tokenizableMethods.length && form.setValue("code", tokenizableMethods[0].code);
        }
        else {
            form.setValue("code", methods[0].code);
        }
    }, [firstMethodCode, isSubscription, isFreeTrial]);
    useEffect(() => {
        setSelectedPayment(code);
        onSelect(code);
    }, [onSelect, code]);
    return (_jsx("div", { className: styles.wrapper, "data-testid": "payment-method-selector", children: _jsx(Form, { form: form, children: _jsxs(DEPRECATED_Card, { titleDataTestId: "payment-card", title: __("cart.order.payment_method.title"), variant: "variant4", children: [_jsx("div", { className: styles.subtext, children: `${__("cart.order.payment_method.choose")}*` }), _jsx(FormField, { name: "code", validation: { required: __("validation.field_required") }, render: ({ field }) => (_jsx(RadioGroup, { ...field, value: selectedPayment, className: styles.paymentMethods, children: methods.map(({ code, icon, title, definition, tokenizable }) => {
                                return (_jsx(PaymentMethod, { code: code, title: title, icon: icon, tooltip: definition, tokenizable: tokenizable || false, isSubscription: isSubscription, isFreeTrial: isFreeTrial }, code));
                            }) })) })] }) }) }));
};
//# sourceMappingURL=PaymentMethodSelector.js.map